<template>
    <div>
        <template v-for="(item, index) in items">
            <div :key="index">
                <sav-input
                :test-id-value="item.testId"
                class="mb-5"
                :display-label="items.length > 1 || items.displayLabel"
                :label="existsOrNull(item.label)"
                :type="existsOrNull(item.type)"
                :class-src="existsOrNull(item.classSrc)"
                :options="existsOrNull(item.options)"
                :placeholder="existsOrNull(item.placeholder)"
                :errors="existsOrNull(item.errors)"
                :tooltip="existsOrNull(item.tooltip)"
                :disabled="item.disabled"
                :min="item.min"
                :max="item.max"
                :meta="item.meta"
                :modal-helper="item.modalHelper"
                @input="autoSubmit ? emitData() : null"
                v-model="item.value"
                :on-change="item.onChange"
                />
            </div>
        </template>
        <div class="d-flex justify-content-between align-items-center">
            <button test-id="btn-skip-form" v-if="skip" @click="skipForm" class="px-5 py-2.5 text-sm font-base duration-100 duration-200 bg-gray-200 border-gray-200 hover:bg-gray-300 rounded-xl">
                <small>{{ skip }}</small>
            </button>
            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 hover:bg-green-700 rounded-xl" v-if="displaySubmitButton" @click="emitData" test-id="sav-button">
                <i class="mr-1 fas fa-check"></i> {{$t('composants.form.valider')}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dataSrc: {
            type: Array,
            required: true
        },
        skip: {
            type: String,
        },
        id: {
            type: String
        },
        callback: {},
        canSubmit: {
            type: Boolean,
            default: true
        }
    },

    watch: {
        dataSrc: function(value) {
            this.setItems()
        },
        canSubmit: function(value) {
            this.displaySubmitButton = value
        },
    },

    data() {
        return {
            items: [],
            displaySubmitButton: true,
        }
    },

    computed: {
        autoSubmit() {
            return this.items.length == 1 && this.items[0].type == 'sav-select'
        }
    },

    methods: {
        existsOrNull(element) {
            return element || null
        },

        emitData() {
            let errorFound = false
            this.items.forEach((item) => {
                item.errors = []
                if (item.required && !item.value) {
                    item.errors.push(this.$t('composants.form.champ_incomplet'))
                    errorFound = true
                }
                if (item.validations) {
                    item.validations.forEach(validation => {
                        if (!eval(validation.rule)) {
                            item.errors.push(validation.message)
                            errorFound = true
                        }
                    });
                }
            })
            if (!errorFound) {
                this.$emit('submit', this.items)

                if (this.callback) {
                    this.callback(this.items, this.id)
                }
            } else {
                this.items =  [...this.items]
            }
        },

        skipForm() {
            this.items.forEach((item) => {
                item.value = null
            })
            if (this.callback) {
                this.callback(this.items, this.id)
            }
        },

        setItems() {
            this.items = this.dataSrc
            if (this.autoSubmit) {
                this.displaySubmitButton = false
            }
        }
    },

    mounted() {
        this.displaySubmitButton = this.canSubmit
        this.setItems()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavForm.vue